import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppService } from './logic/app.service';
import { AppLogicService } from './logic/app-service/app-logic.service';
import { AppDaoService } from './dao/app-dao.service';
import { AppStorageDaoService } from './dao/app-storage-dao/app-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: AppService, useClass: AppLogicService },
    { provide: AppDaoService, useClass: AppStorageDaoService },
  ],
})
export class AppServiceModule {}
